import _ from 'lodash'

export const changes = (a, b) => {
   return _.reduce(
      _.uniq((a || b || []).concat(b || [])),
      ({added, removed, unchanged}, e) => {
         if (-1 === _.indexOf(a, e)) {
            return {added, removed: removed.concat(e), unchanged}
         } else if (-1 === _.indexOf(b, e)) {
            return {added: added.concat(e), removed, unchanged}
         } else {
            return {added, removed, unchanged: unchanged.concat(e)}
         }
      },
      {added: [], removed: [], unchanged: []},
   )
}



// WEBPACK FOOTER //
// lib/util/data.js